import siteConfig from "./siteConfig.json";

export const contactPageData = {
  seo: {
    title: "Contact Us | NextEra Abroad",
    description:
      "Talk to NextEra Abroad for personalized study abroad guidance. Connect with our team by call, WhatsApp, email, or inquiry form."
  },
  hero: {
    kicker: "Contact NextEra Abroad",
    title: "Start the Conversation That Shapes Your Future",
    subtitle:
      "Whether you are a student or parent, our team is here to guide your next step with clarity, empathy, and expert support.",
    trustChips: [
      "Quick response support",
      "Student-first guidance",
      "Clear communication"
    ],
    primary: {
      label: "Book Free Counselling",
      to: "#contact-form"
    },
    secondary: {
      label: "Talk to an Expert",
      to: siteConfig.links.talkToExpert
    },
    supportPoints: [
      "Profile-focused first consultation",
      "Step-by-step planning clarity",
      "Welcoming support for families"
    ]
  },
  details: [
    {
      label: "Mobile Number",
      value: siteConfig.contact.phone,
      actionLabel: "Call now",
      href: `tel:${siteConfig.contact.phone.replace(/\s+/g, "")}`,
      type: "phone"
    },
    {
      label: "Email Address",
      value: siteConfig.contact.email,
      actionLabel: "Send email",
      href: `mailto:${siteConfig.contact.email}`,
      type: "email"
    },
    {
      label: "Office Address",
      value: siteConfig.contact.address,
      actionLabel: "Open in Maps",
      href: siteConfig.contact.mapUrl,
      type: "address"
    },
    {
      label: "Office Hours",
      value: "Mon - Sat | 10:00 AM - 7:00 PM",
      actionLabel: "Book appointment",
      href: siteConfig.links.bookCounselling,
      type: "hours"
    }
  ],
  quickConnect: [
    {
      title: "Call Now",
      text: "Speak directly with our counselling team.",
      href: `tel:${siteConfig.contact.phone.replace(/\s+/g, "")}`
    },
    {
      title: "WhatsApp Us",
      text: "Get quick answers and guidance updates.",
      href: `https://wa.me/${siteConfig.contact.phone.replace(/\D+/g, "")}`
    },
    {
      title: "Email Us",
      text: "Share your profile and we will respond clearly.",
      href: `mailto:${siteConfig.contact.email}`
    },
    {
      title: "Visit Office",
      text: "Meet us in person for focused planning.",
      href: siteConfig.contact.mapUrl
    }
  ],
  form: {
    title: "Send Your Inquiry",
    subtitle:
      "Tell us a little about your goals and we will help you take the right next step.",
    submitLabel: "Send Inquiry",
    destinationOptions: ["USA", "Canada", "UK", "Australia", "UAE", "New Zealand", "Europe", "Ireland", "Germany"],
    studyLevelOptions: ["Undergraduate", "Postgraduate", "MBA", "Diploma", "Not Sure Yet"]
  },
  location: {
    title: "Visit Our Office",
    subtitle:
      "Prefer a face-to-face conversation? You are always welcome for a focused counselling session.",
    mapLabel: "Open Location in Google Maps",
    mapHref: siteConfig.contact.mapUrl,
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80"
  },
  reassurance: {
    title: "You’ll Be Guided, Not Pressured",
    points: [
      "Personalized guidance for every student profile",
      "Transparent communication at every milestone",
      "Support from planning to application and visa readiness",
      "Welcoming approach for both students and parents"
    ]
  },
  finalCta: {
    title: "Your Global Journey Can Start with One Conversation",
    subtitle:
      "Reach out today and let’s create a confident plan tailored to your goals.",
    primary: {
      label: "Book Free Counselling",
      to: siteConfig.links.bookCounselling
    },
    secondary: {
      label: "Talk to an Expert",
      to: siteConfig.links.talkToExpert
    }
  }
};
